export const enum TESTER_URLS {
    TESTER_URL = '//testeradapi.interia.pl/api-tester/testing',
    OLD_TESTER_URL = '//testeradapi.interia.pl/api-v2/testing',
    TESTER_URL_ITG = '//tester-api.itg.ipl.paas.work/api-v2/testing',
}

export const enum TESTER_PARAMS {
    TESTER_PARAM_ITG = 'adtester2023_itg_',
    TESTER_PARAM_V2 = 'adtester2023_',
    TESTER_PARAM = 'inpltester2ad',
}

export const COOKIE_TEST_POCZTA = 'adTester';
